"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIcon = getIcon;
exports.getReportcardStatusDisplay = getReportcardStatusDisplay;
var queryString_1 = require("../helpers/queryString");
var ReportcardsModel = /** @class */ (function () {
    function ReportcardsModel($http, APPURL) {
        this.$http = $http;
        this.URLS = {
            FETCH: APPURL + "/api/v1/reportcards",
            UPDATE: APPURL + "/api/v1/reportcards",
            CREATE: APPURL + "/api/v1/reportcards",
        };
        this.data = [];
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
    }
    ReportcardsModel.prototype.extract = function (result) {
        return result.data;
    };
    ReportcardsModel.prototype.cacheResults = function (result) {
        this.data = this.extract(result);
        return this.data;
    };
    ReportcardsModel.prototype.getReportcardByID = function (id) {
        return this.$http
            .get(this.URLS.FETCH + "/" + id)
            .then(this.cacheResults);
    };
    ReportcardsModel.prototype.getSignatures = function (id) {
        return this.$http
            .get(this.URLS.FETCH + "/" + id + "/signature")
            .then(this.cacheResults);
    };
    ReportcardsModel.prototype.get = function (data) {
        if (data === void 0) { data = null; }
        if (data != null) {
            return this.$http
                .get(this.URLS.FETCH + "?" + (0, queryString_1.toQueryString)(data))
                .then(this.cacheResults);
        }
        return this.$http
            .get(this.URLS.FETCH)
            .then(this.cacheResults);
    };
    ReportcardsModel.prototype.update = function (request) {
        return this.$http
            .put(this.URLS.FETCH + "/" + request.id, request)
            .then(this.cacheResults);
    };
    ReportcardsModel.prototype.create = function (request) {
        return this.$http
            .post(this.URLS.FETCH, request)
            .then(this.cacheResults);
    };
    ReportcardsModel.prototype.submitGrades = function (data) {
        return this.$http
            .post(this.URLS.FETCH + "/submit-grades", data)
            .then(this.cacheResults);
    };
    ReportcardsModel.prototype.submitPassFailGrade = function (data) {
        var payload = {
            grade: data.grade,
            drive_id: data.drive_id,
            reportcard_id: data.reportcard_id,
        };
        return this.$http
            .post(this.URLS.FETCH + "/submit-grades", payload)
            .then(this.cacheResults);
    };
    ReportcardsModel.prototype.submitGenericGrade = function (data) {
        return this.$http
            .post(this.URLS.FETCH + "/submit-grades", data)
            .then(this.cacheResults);
    };
    ReportcardsModel.prototype.unlockReportCard = function (reportcard_id) {
        return this.$http
            .put(this.URLS.FETCH + "/" + reportcard_id + "/unlock", {})
            .then(this.cacheResults);
    };
    ReportcardsModel.prototype.destroy = function (card) {
        return this.$http
            .delete(this.URLS.FETCH + "/" + card.id)
            .then(this.cacheResults);
    };
    ReportcardsModel.prototype.destroyCollection = function (reportcards) {
        return this.$http
            .post(this.URLS.FETCH + "/delete-batch", reportcards)
            .then(this.cacheResults);
    };
    ReportcardsModel.prototype.getUnsignedReportCards = function (student_id) {
        return this.$http
            .get(this.URLS.FETCH +
            "?student_id=" +
            student_id +
            "&signed=0&signature_required=1")
            .then(this.cacheResults);
    };
    ReportcardsModel.prototype.submitSignature = function (reportcard_id, signature_data, signee_type) {
        return this.$http
            .post(this.URLS.FETCH + "/" + reportcard_id + "/signature", {
            signature_data: signature_data,
            signee_type: signee_type,
        })
            .then(this.cacheResults);
    };
    return ReportcardsModel;
}());
function getIcon(name) {
    var iconName = null;
    switch (name) {
        case "Acceleration":
            iconName = "acceleration";
            break;
        case "Blind Spots":
            iconName = "blind_spots";
            break;
        case "Braking":
            iconName = "braking";
            break;
        case "Changing Lanes":
            iconName = "changing_lanes";
            break;
        case "Following Distance":
            iconName = "following_distance";
            break;
        case "In town - IT":
            iconName = "in_town";
            break;
        case "Interstate - I":
            iconName = "interstate";
            break;
        case "Left Turns":
            iconName = "left_turns";
            break;
        case "Night Driving - N":
            iconName = "observation";
            break;
        case "Parallel Parking - P":
            iconName = "parallel_parking";
            break;
        case "General Parking":
            iconName = "parking";
            break;
        case "Residential - R":
            iconName = "residential";
            break;
        case "Right Turns":
            iconName = "right_turns";
            break;
        case "Straight Line Reverse":
            iconName = "straight_line_reverse";
            break;
        case "Turn About":
            iconName = "turn_about";
            break;
        default:
            name.replace(" ", "_").replace("-", "_").toLowerCase();
    }
    return iconName;
}
function getReportcardStatusDisplay(status) {
    var result = status;
    if (status === "green") {
        return "Awesome job!";
    }
    if (status === "yellow") {
        return "Good, but not great!";
    }
    if (status === "red") {
        return "Needs work, keep practicing!";
    }
    if (status === "grey") {
        return "Not Covered";
    }
    return result;
}
ReportcardsModel.$inject = ["$http", "APPURL"];
exports.default = ReportcardsModel;
